import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'toastr/build/toastr.min.css';
import 'toastr/build/toastr.min.js';
import * as serviceWorker from './serviceWorker';
import createHost from 'cross-domain-storage/host';

const guestOrigin =
  process.env.REACT_APP_GUEST_ORIGIN || 'http://localhost:4000';

createHost([
  {
    origin: guestOrigin,
    allowedMethods: ['get', 'set', 'remove'],
  },
]);

/**
 * Fallback error UI that can be injected if React fails completely
 */
const showFallbackErrorUI = (errorMessage) => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="display: flex; justify-content: center; align-items: center; min-height: 100vh; background-color: #f5f5f5; padding: 24px; font-family: Arial, sans-serif;">
        <div style="background-color: white; padding: 32px; max-width: 600px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
          <h1 style="color: #d32f2f; margin-top: 0;">Application Error</h1>
          <p>The application encountered a critical error and cannot start.</p>
          <p>Please try the following:</p>
          <ul>
            <li>Clear your browser cache and cookies</li>
            <li>Try a different browser</li>
            <li>Contact support if the problem persists</li>
          </ul>
          <div style="margin-top: 24px;">
            <button
              onclick="localStorage.clear(); sessionStorage.clear(); window.location.href = '/login';"
              style="width: 100%; padding: 12px; background-color: #1976d2; color: white; border: none; border-radius: 4px; font-size: 16px; cursor: pointer; margin-bottom: 12px;">
              Clear Data and Go to Login
            </button>
            <button
              onclick="window.location.reload();"
              style="width: 100%; padding: 12px; background-color: white; color: #1976d2; border: 2px solid #1976d2; border-radius: 4px; font-size: 16px; cursor: pointer;">
              Reload Page
            </button>
          </div>
          ${process.env.NODE_ENV === 'development' ? `
            <div style="margin-top: 24px; padding: 16px; background-color: #f5f5f5; border-radius: 4px;">
              <h3>Error Details (Development Only):</h3>
              <pre style="overflow: auto; max-height: 200px; font-size: 12px;">${errorMessage || 'Unknown error'}</pre>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }
};

/**
 * Global error handler for uncaught errors
 */
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);

  // Don't show fallback UI for resource loading errors (scripts, images, etc.)
  if (event.filename) {
    return;
  }

  // If React hasn't rendered yet or has crashed, show fallback
  const rootElement = document.getElementById('root');
  if (!rootElement || rootElement.innerHTML === '') {
    showFallbackErrorUI(event.error?.message || event.message);
  }
});

/**
 * Global handler for unhandled promise rejections
 */
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);

  // If it's an auth error, clear and redirect
  if (event.reason?.response?.status === 401 ||
      event.reason?.message?.toLowerCase().includes('unauthorized') ||
      event.reason?.message?.toLowerCase().includes('token')) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
  }
});

/**
 * Try to render React app with error handling
 */
try {
  ReactDOM.render(<App />, document.getElementById('root'));
} catch (error) {
  console.error('Failed to render React app:', error);
  showFallbackErrorUI(error.message);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
